import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import { DatabasePageParams } from '../../components/pages/DatabasePage/types';
import { MainModalFieldProps, TextPreprocessor } from '../types';
import { isValidTextValue } from '../utils';

export const useModalTextField = (mainModalField: MainModalFieldProps, preprocessText?: TextPreprocessor) => {
  const {
    handleBlur,
    handleKeyDown,
    updateCellValue,
    value,
    dataType,
  } = mainModalField;

  const [textValue, setTextValue] = useState('');
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const { databaseSlug, tableSlug } = useParams<DatabasePageParams>();

  useEffect(() => {
    setTextValue(isValidTextValue(value) ? String(value) : '');
  }, [value]);

  const onBlur = async () => {
    handleBlur?.();
    if (tableSlug) {
      await updateCellValue?.(databaseSlug, tableSlug, dataType === 'number' ? Number(textValue) : textValue);
    }
  };

  const onKeyDown = async (event?: React.KeyboardEvent<HTMLTextAreaElement>) => {
    handleKeyDown?.(event);
    if (event && ['Enter', 'Tab'].includes(event.key)) {
      const cellValue = (event?.target as HTMLTextAreaElement).value;
      textAreaRef.current?.blur();
      if (tableSlug) {
        await updateCellValue?.(databaseSlug, tableSlug, dataType === 'number' ? Number(cellValue) : cellValue);
      }
    }
  };

  const handleTextChanged = (
    ref: React.RefObject<HTMLTextAreaElement>,
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    if (ref.current) {
      if (preprocessText) {
        preprocessText(ref, event);
      }

      const textAreaValue = ref.current.value;
      setTextValue(textAreaValue);
    }
  };

  return {
    handleBlur: onBlur,
    handleKeyDown: onKeyDown,
    handleTextChanged,
    textAreaRef,
    textValue,
  };
};
